export const lists = {
  workAnalytics: {
    columnNames: [
      'Имя сотрудника',
      'Роль',
      'Отработано часов',
      'Автоматически закрыто смен',
      'Открыто проектов',
      'Сроков сдачи нарушено',
      'Изготовлено продуктов',
    ],
  },
  shiftsCalendars: {
    columnNames: [
      'Название',
      'Дополнительное описание',
      'Создан',
      'Обновлен',
    ],
    rowNames: [
      'name',
      'description',
      'created_at',
      'updated_at',
    ],
    filterFields: [
      {
        name: "description",
        title: "Дополнительное описание",
        value: "",
      },
    ],
  },
  users: {
    foreignKeyValues: {
      role: 'name',
    },
    columnNames: [
      "Имя",
      "Фамилия",
      "Отчество",
      "Логин",
      "Создан",
      "Обновлен",
      "Последний вход",
      "Роль",
    ],
    rowNames: [
      "name",
      "surname",
      "patronymic",
      "login",
      "created_at",
      "updated_at",
      "authorized_at",
    ],
    orderFields: {
      "Имя": "name",
      "Фамилия": "surname",
      "Отчество": "patronymic",
      "Логин": "login",
      "Создан": "created_at",
      "Обновлен": "updated_at",
      "Последний вход": "authorized_at",
      "Роль": "role_id",
    },
    filterFields: [
      {
        name: "surname",
        title: "Фамилия",
        value: "",
      },
      {
        name: "patronymic",
        title: "Отчество",
        value: "",
      },
      {
        name: "login",
        title: "Логин",
        value: "",
      },
    ],
  },
  loginHistory: {
    columnNames: [
      "Сотрудник",
      "Роль",
      "Дата попытки",
      "Статус",
      "Причина неудачи",
      "Снимок экрана",
    ],
    orderFields: {
      "Сотрудник": "user_id",
      "Роль": "role_id",
      "Дата попытки": "created_at",
      "Статус": "with_failure",
      "Причина неудачи": "failure_reason",
    },
    filterFields: [
      {
        name: "with_failure",
        title: "Статус попытки",
        value: "",
        selectOptions: [
          {
            label: "Успех",
            value: "0",
          },
          {
            label: "Провал",
            value: "1",
          },
        ],
      },
      {
        name: "failure_reason",
        title: "Причина неудачи",
        value: "",
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/user/constants/tables.js